import { useAppSelector } from '@monorepo/shared';
import { CSSProperties, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  selectAccountAllHa,
  selectAccountAllInstances
} from '@monorepo/shared/store/haInstanceSlice';
import { Divider, FlexboxGrid, Table } from 'rsuite';
import { columnLeft, subTitleStyle } from './AccountDetail';
import { selectRegions } from '@monorepo/shared/store/authSlice';

export const AccountRegion = () => {
  const { regionId, accountId } = useParams();
  const navigate = useNavigate();
  const [region, setRegion] = useState<Record<string, any>>({});
  const [haData, setHaData] = useState<Record<string, any>[]>([]);
  const [instanceData, setInstanceData] = useState<Record<string, any>[]>([]);
  const regions = useAppSelector(selectRegions);
  const accountRegionInstances = useAppSelector(selectAccountAllInstances);
  const accountRegionHas = useAppSelector(selectAccountAllHa);
  const { Column, HeaderCell, Cell } = Table;
  useEffect(() => {
    if (regionId && regions?.[regionId]) {
      setRegion(regions[regionId]);
    }
  }, [regionId, regions]);
  useEffect(() => {
    const accountData = accountRegionHas?.[accountId || ''];
    if (accountData) {
      const data = accountData?.filter(
        (obj: Record<string, any>) => obj.region_alias === regionId
      );
      setHaData(data);
    }
  }, [accountRegionHas, regionId]);
  useEffect(() => {
    const accountData = accountRegionInstances?.[accountId || ''];
    if (accountData && regionId) {
      const data = accountData?.filter(
        (obj: Record<string, any>) => obj.region?.alias === regionId
      );
      setInstanceData(data);
    }
  }, [accountRegionInstances, regionId]);
  const styleCenter: CSSProperties = {
    display: 'flex',
    height: '60px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    overflow: 'hidden'
  };
  const textStyle: CSSProperties = {
    fontSize: '1.0em',
    fontWeight: 500
  };

  const titleStyle: CSSProperties = {
    paddingBottom: 5,
    whiteSpace: 'nowrap',
    fontWeight: 400,
    fontSize: '0.8em',
    opacity: 0.8,
    textTransform: 'uppercase'
  };

  return (
    <div
      className="account-region-container"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <div className="region-info">
        <div
          className="title"
          style={{
            fontSize: '1.2em',
            letterSpacing: '2px',
            marginBottom: '20px'
          }}
        >
          {'Region Info'}
        </div>
        <div className="list">
          <FlexboxGrid>
            {/*icon*/}
            <FlexboxGrid.Item colspan={6} style={columnLeft}>
              <div style={subTitleStyle}>Region Name</div>
              <div style={textStyle}>{regionId}</div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item colspan={6} style={columnLeft}>
              <div style={subTitleStyle}>Region Description</div>
              <div style={textStyle}>{region?.name}</div>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </div>
      </div>
      <Divider />
      {/* <div className="ha-instances">
        <div
          className="title"
          style={{
            fontSize: '1.2em',
            letterSpacing: '2px',
            marginBottom: '20px'
          }}
        >
          {'Region Cluster'}
        </div>
        <div className="ha-table">
          <Table
            virtualized
            bordered
            cellBordered
            fillHeight
            data={haData}
            renderEmpty={() => renderEmpty('No Cluster Found')}
            onRowClick={(row) => {
              navigate(`ha/${row?.ha_id}`);
            }}
          >
            <Column flexGrow={1}>
              <HeaderCell>Cluster Name</HeaderCell>
              <Cell dataKey="ha_name" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Region</HeaderCell>
              <Cell dataKey="region_alias" />
            </Column>
          </Table>
        </div>
      </div>
      <Divider /> */}
      <div
        className="ha-instances"
        style={{
          flex: '1',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px'
        }}
      >
        <div
          className="title"
          style={{
            fontSize: '1.2em',
            letterSpacing: '2px'
          }}
        >
          {'Region Instance'}
        </div>
        <div className="instances-table" style={{ flex: '1' }}>
          <Table
            virtualized
            fillHeight
            bordered
            cellBordered
            data={instanceData}
            renderEmpty={() => renderEmpty('No Instance Found')}
            onRowClick={(row) => {
              navigate(`instance/${row?.instance_id}`);
            }}
          >
            <Column width={290} fixed>
              <HeaderCell>ID</HeaderCell>
              <Cell dataKey="instance_id" />
            </Column>

            <Column flexGrow={1}>
              <HeaderCell>SN</HeaderCell>
              <Cell dataKey="license_sn" />
            </Column>
            {/* <Column flexGrow={1}>
              <HeaderCell>Cluster Name</HeaderCell>
              <Cell dataKey="ha_name" />
            </Column> */}
            <Column flexGrow={1}>
              <HeaderCell>Region</HeaderCell>
              <Cell>
                {(rowData: Record<string, any>) => {
                  return <span>{rowData?.region?.alias}</span>;
                }}
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Version</HeaderCell>
              <Cell dataKey="firmware" />
            </Column>
          </Table>
        </div>
      </div>
    </div>
  );
};

const renderEmpty: any = (info: any) => (
  <div
    style={{
      height: '100%',
      display: 'grid',
      placeItems: 'center'
    }}
  >
    {info}
  </div>
);
